import { useCreateSearchLink } from "../../../../utils/hooks/partSearch";
import React, { useState } from "react";
import useContainer from "../../../../utils/hooks/inventory/getContainer";
import {
  ContainerTools,
  ContainerToolsTitle,
  HorizontalList,
} from "../BarcodeLink/BarcodeLinkStyles";
import ContainerSummary from "../InventoryUpdates/ContainerSummary";
import Button from "../../../common/Button";
import Link from "next/link";
import Modal from "../../../common/Modal";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import LoadingIcon from "../../../common/LoadingIcon";
import ContainerDetails from "../../../component-search/PartDrawer/Inventory/PhysicalInventory/ContainerDetails";
import ScanForMatch from "../InventoryUpdates/ScanForMatch";
import UpdateContainerLocation from "../../../component-search/PartDrawer/Inventory/PhysicalInventory/UpdateContainerLocation";
import { ItemType } from "../InventoryUpdates/MoveContainerAction";
import { useRouter } from "next/router";
import DeleteContainer from "../../../component-search/PartDrawer/Inventory/PhysicalInventory/DeleteContainer";

export default function ContainerPage({
  containerBarcode,
  onUpdate,
}: {
  containerBarcode: string;
  onUpdate?: () => void;
}) {
  const router = useRouter();
  const createSearchLink = useCreateSearchLink();
  const [editContainer, setEditContainer] = useState(false);
  const [moveContainer, setMoveContainer] = useState(false);
  const [deleteContainer, setDeleteContainer] = useState(false);
  const [scanningForMatch, setScanningForMatch] = useState(false);
  const { container, refreshContainer } = useContainer(containerBarcode);

  const finishEdit = () => {
    refreshContainer();
    setEditContainer(false);
  };

  const finishScanningForPart = () => {
    setScanningForMatch(false);
  };

  const finishMoveContainer = () => {
    setDeleteContainer(false);
    setMoveContainer(false);
  };

  const finishDeleteContainer = () => {
    void router.push("/internal/inventory");
  };

  return (
    <>
      <ContainerTools>
        <ContainerToolsTitle>{containerBarcode}</ContainerToolsTitle>
        <ContainerSummary
          containerBarcode={containerBarcode}
          displayAllocations
          displayHistory
          onUpdate={onUpdate}
        >
          <ContainerTools>
            <HorizontalList>
              <Button
                label={"Edit container"}
                onClick={() => setEditContainer(true)}
              />
              <Button
                label={"Move container"}
                onClick={() => setMoveContainer(true)}
              />
              <Button
                label={"Delete container"}
                onClick={() => setDeleteContainer(true)}
              />
              <Button
                label={"Scan for a match"}
                onClick={() => setScanningForMatch(true)}
              />
            </HorizontalList>
            <Link
              href={createSearchLink({
                updateSearchParameters: { searchTerms: containerBarcode },
              })}
              target={"_blank"}
            >
              Show part in part search
            </Link>
          </ContainerTools>
        </ContainerSummary>
      </ContainerTools>
      <Modal isOpen={editContainer} onRequestClose={finishEdit}>
        <ModalContentWithCloseButton closeModal={finishEdit} fullScreen>
          {container === null ? (
            <LoadingIcon text={"Loading container..."} />
          ) : (
            <ContainerDetails
              partId={container.part_id}
              selectedContainer={container}
              onFinishedEditing={() => {
                finishEdit();
                onUpdate?.();
              }}
              onCancel={finishEdit}
            />
          )}
        </ModalContentWithCloseButton>
      </Modal>
      <Modal isOpen={scanningForMatch} onRequestClose={finishScanningForPart}>
        <ModalContentWithCloseButton
          closeModal={finishScanningForPart}
          fullScreen
        >
          <ScanForMatch
            containerToFind={containerBarcode}
            onFound={finishScanningForPart}
          />
        </ModalContentWithCloseButton>
      </Modal>
      <Modal isOpen={moveContainer} onRequestClose={finishMoveContainer}>
        <ModalContentWithCloseButton closeModal={finishMoveContainer}>
          <UpdateContainerLocation
            selectedContainers={[containerBarcode]}
            itemType={ItemType.PARTS_CONTAINERS}
            onCancel={finishMoveContainer}
            onFinishedEditing={finishMoveContainer}
          />
        </ModalContentWithCloseButton>
      </Modal>
      <Modal isOpen={deleteContainer} onRequestClose={finishMoveContainer}>
        <ModalContentWithCloseButton closeModal={finishMoveContainer}>
          <DeleteContainer
            containerBarcode={containerBarcode}
            onFinishedEditing={finishDeleteContainer}
          />
        </ModalContentWithCloseButton>
      </Modal>
    </>
  );
}
